import type { FC } from 'react';

import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

import { HelpChapterCrashAutoCashingOut } from './HelpChapterCrashAutoCashingOut';

export const HelpChapterCrashAutoCashingOutConnected: FC = () => {
  const DEFAULT_MULTIPLIER_VALUE = 100;
  const maxMultiplier = useConfigSlice.tableConfig()?.customMultiplierCap ?? DEFAULT_MULTIPLIER_VALUE;

  return <HelpChapterCrashAutoCashingOut maxMultiplier={maxMultiplier} />;
};
